import { HowItWorksContentProps } from '@/components/cohort/HowItWorks/HowItWorks';

export const HowItWorksContent: HowItWorksContentProps = {
  eyebrow: 'TAKE THE NEXT STEP',
  heading: 'Calculate your numbers',
  subtext: 'We’ve slashed the time, paperwork and hassle. Get a quote fast and start owning!',
  gridItems: [
    {
      imgSrc: '/next-assets/images/cohort/hiw-calculate.svg',
      imgAlt: 'Calculator',
      title: 'Calculate',
      body: 'Calculate your borrowing power and your repayments; check your eligibility. No credit checks here!',
      pill: '3 mins',
    },
    {
      imgSrc: '/next-assets/images/cohort/hiw-apply.svg',
      imgAlt: 'Clock',
      title: 'Apply',
      body: "Our online application is simple. Submit and we'll get you pre-approved in days not weeks.",
      pill: '15 mins',
    },
    {
      imgSrc: '/next-assets/images/cohort/hiw-switch.svg',
      imgAlt: 'Arrows',
      title: 'Settle',
      body: 'Once approved, review and return your docs. We’ll get you sorted and into your new home.',
      pill: '',
    },
  ],
};
